import React from 'react';
import './App.css';
import './modules/firebase/Config'
import DataUploadPage from './modules/pages/user_data_upload_page'

function App() {
  return <DataUploadPage />;
}

export default App;
